import {
  Calendar,
  HeadphonesIcon,
  ShoppingBag,
  Sparkles,
} from 'lucide-react'

export const PERSONAS = [
  {
    id: 'sales',
    icon: ShoppingBag,
    label: 'Vendedor',
    accent: '#FE9F34',
    sample:
      'Qualifica leads, apresenta produtos, tira dúvidas e conduz o cliente até o fechamento.',
  },
  {
    id: 'support',
    icon: HeadphonesIcon,
    label: 'Suporte',
    accent: '#34ADFE',
    sample:
      'Responde dúvidas frequentes, soluciona pequenos problemas e escala para um humano quando necessário.',
  },
  {
    id: 'scheduling',
    icon: Calendar,
    label: 'Agendamento',
    accent: '#34FE9F',
    sample:
      'Coleta dados, oferece horários disponíveis e confirma agendamentos automaticamente.',
  },
  {
    id: 'general',
    icon: Sparkles,
    label: 'Multiuso',
    accent: '#AD34FE',
    sample:
      'Um assistente versátil que aprende com seus documentos e responde sobre qualquer assunto da sua empresa.',
  },
]

export function getPersona(id) {
  return PERSONAS.find((p) => p.id === id)
}
